export default __webpack_public_path__ + "static/media/thyme.03b2943f.jpg";